type ReportingFrequency = 'monthly' | 'quarterly' | 'annual';

export function getPreviousPeriod(frequency: ReportingFrequency, timezone: string = 'UTC'): string {
  const now = new Date(new Date().toLocaleString('en-US', { timeZone: timezone }));
  const year = now.getFullYear();
  const month = now.getMonth();

  switch (frequency) {
    case 'monthly': {
      const previousMonth = month === 0 ? 11 : month - 1;
      const previousYear = month === 0 ? year - 1 : year;
      return `${previousYear}-${String(previousMonth + 1).padStart(2, '0')}`;
    }

    case 'quarterly': {
      const currentQuarter = Math.floor(month / 3) + 1;
      const previousQuarter = currentQuarter === 1 ? 4 : currentQuarter - 1;
      const previousYear = currentQuarter === 1 ? year - 1 : year;
      return `Q${previousQuarter} ${previousYear}`;
    }

    case 'annual': {
      return String(year - 1);
    }

    default:
      return '';
  }
}
